export const ADD_ADFS_APP = 'add_adfs_app';
export const ADD_MULTIPLE_ADFS_APPS = 'add_multiple_adfs_apps';
export const UPDATE_ADFS_APP = 'update_adfs_app';
export const REMOVE_ADFS_APP = 'remove_adfs_app';
export const ADD_PINGFED_APP = 'add_pingfed_app';
export const ADD_MULTIPLE_PINGFED_APPS = 'add_multiple_pingfed_apps';
export const UPDATE_PINGFED_APP = 'update_pingfed_app';
export const REMOVE_PINGFED_APP = 'remove_pingfed_app';
export const ADD_AZURE_CONNECTOR = 'add_azure_connector';
export const REMOVE_AZURE_CONNECTOR = 'remove_azure_connector';
export const ADD_NEW_AZURE_CONNECTOR = 'add_new_azure_connector';
export const REMOVE_NEW_AZURE_CONNECTOR = 'remove_new_azure_connector';
export const UPDATE_CONNECTOR = 'update_connector';
export const UPDATE_CONNECTORS_FIELDS = 'update_connector_fields';
export const ADD_NAMING_CONVENTION = 'add_naming_convention';
export const REMOVE_NAMING_CONVENTION = 'remove_naming_convention';
export const ADD_SSO_APP = 'add_sso_app';
export const UPDATE_SSO_APP = 'update_sso_app';
export const REMOVE_SSO_APP = 'remove_sso_app';
export const ADD_SSO_VENDOR = 'add_sso_vendor';
export const UPDATE_SSO_VENDOR = 'update_sso_vendor';
